module.exports = __webpack_public_path__ + "img/emoticon-nps-5-on.b70389d5.svg";